import { render, staticRenderFns } from "./DistributorDatas.vue?vue&type=template&id=c999b6ec&scoped=true"
import script from "./DistributorDatas.vue?vue&type=script&lang=ts"
export * from "./DistributorDatas.vue?vue&type=script&lang=ts"
import style0 from "./DistributorDatas.vue?vue&type=style&index=0&id=c999b6ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c999b6ec",
  null
  
)

export default component.exports